var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.dataList },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function (scope) {
                              return [
                                slot === "status"
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("div", [_vm._v("状态")]),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content:
                                                "[开通状态和同步状态]与物流发货状态无关",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-question",
                                              staticStyle: {
                                                "font-size": "18px",
                                                "margin-top": "3px",
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                slot === "orderNo"
                                  ? _c("div", [_vm._v("订单编号")])
                                  : _vm._e(),
                                slot === "postName"
                                  ? _c("div", [_vm._v("收货人")])
                                  : _vm._e(),
                                slot === "address"
                                  ? _c("div", [_vm._v("收货地址")])
                                  : _vm._e(),
                                slot === "info"
                                  ? _c("div", [_vm._v("商品名称")])
                                  : _vm._e(),
                                slot === "price"
                                  ? _c("div", [_vm._v("金额")])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "orderNo"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "itemN",
                                          style: { zIndex: 100 - scope.$index },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                width: "98%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 创建时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .createdTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 支付时间：" +
                                                          _vm._s(
                                                            scope.row.payTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 支付单号：" +
                                                          _vm._s(
                                                            scope.row
                                                              .outTradeNo ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 发货时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .postTime || "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-dropdown",
                                                    {
                                                      attrs: {
                                                        placement: "bottom",
                                                      },
                                                      on: {
                                                        command: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleCommand(
                                                            $event,
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "el-dropdown-link",
                                                          staticStyle: {
                                                            color: "#4168e7",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(" 更多"),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-arrow-down el-icon--right",
                                                            staticStyle: {
                                                              color: "#4168e7",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-dropdown-menu",
                                                        {
                                                          attrs: {
                                                            slot: "dropdown",
                                                          },
                                                          slot: "dropdown",
                                                        },
                                                        [
                                                          _c(
                                                            "el-dropdown-item",
                                                            {
                                                              attrs: {
                                                                command: "1",
                                                              },
                                                            },
                                                            [_vm._v("查看")]
                                                          ),
                                                          scope.row.status == 4
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "2",
                                                                  },
                                                                },
                                                                [_vm._v("发货")]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 2
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "3",
                                                                  },
                                                                },
                                                                [_vm._v("备货")]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 5
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "4",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "修改物流单号"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status ==
                                                            5 ||
                                                          scope.row.status == 6
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "5",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "物流信息"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row
                                                            .syncWxPostStatus ==
                                                          2
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "6",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "手动同步"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(scope.row.orderNo) + " "
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "postName"
                                  ? [
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.postName)),
                                      ]),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.postPhone)),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "contact"
                                  ? [
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.postName)),
                                      ]),
                                      _c("p", [
                                        _vm._v(_vm._s(scope.row.postContact)),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "info"
                                  ? _vm._l(
                                      scope.row.orderDetailList,
                                      function (item, index) {
                                        return _c("p", { key: index }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.goodsName) +
                                              "   " +
                                              _vm._s(item.goodsSkuName) +
                                              "*" +
                                              _vm._s(item.goodsQuantity) +
                                              " "
                                          ),
                                        ])
                                      }
                                    )
                                  : _vm._e(),
                                slot === "address"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.postDistrictAddress
                                            ) +
                                            _vm._s(scope.row.postAddress) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "status"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.statusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.status == 99,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.status < 4,
                                              },
                                              "round",
                                              {
                                                "success-bg":
                                                  scope.row.status === 6,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.statusLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      scope.row.syncWxPostStatus != 0
                                        ? _c("p", [
                                            _vm._v(
                                              "【" +
                                                _vm._s(
                                                  scope.row
                                                    .syncWxPostStatusLabel
                                                ) +
                                                "】"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                slot === "price"
                                  ? [
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "总价：￥" +
                                              _vm._s(scope.row.goodsAmount)
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "运费：￥" +
                                              _vm._s(scope.row.freightAmount)
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "实收：￥" +
                                              _vm._s(scope.row.receivableAmount)
                                          ),
                                        ]),
                                      ],
                                    ]
                                  : _vm._e(),
                                slot === "operation"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-right": "20px",
                                                cursor: "pointer",
                                                color: "#409eff",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.platformIogisticsOrderDetail(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 查看 ")]
                                          ),
                                          scope.row.status == 4
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "20px",
                                                    cursor: "pointer",
                                                    color: "#409eff",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.outGoods(
                                                        scope.row,
                                                        "delivery"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 发货 ")]
                                              )
                                            : _vm._e(),
                                          scope.row.status == 2
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "20px",
                                                    cursor: "pointer",
                                                    color: "#409eff",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.stock(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 备货 ")]
                                              )
                                            : _vm._e(),
                                          scope.row.status == 5
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "20px",
                                                    cursor: "pointer",
                                                    color: "#409eff",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.outGoods(
                                                        scope.row,
                                                        "edit"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 修改物流单号 ")]
                                              )
                                            : _vm._e(),
                                          scope.row.status == 5 ||
                                          scope.row.status == 6
                                            ? _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "20px",
                                                    cursor: "pointer",
                                                    color: "#409eff",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.lookInfo(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 物流信息 ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApply,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApply = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [_vm._v("是否审核通过？")]),
            _c(
              "div",
              { staticStyle: { "margin-top": "18px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.radio,
                      callback: function ($$v) {
                        _vm.radio = $$v
                      },
                      expression: "radio",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 3 } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: 6 } }, [_vm._v("驳回")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.radio == 3
              ? _c("div", { staticClass: "pass" }, [
                  _vm._v(" 确认后，金额"),
                  _c("span", { staticClass: "price" }, [_vm._v("￥1000.00")]),
                  _vm._v("将退回买家账户 "),
                ])
              : _vm._e(),
            _vm.radio == 6
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "24px",
                      width: "90%",
                      "margin-bottom": "24px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px", width: "10%" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "5",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }